import React from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.inspections_answer_by_type';
export function SubToggleCell({ row, onToggle }) {
    const isSystem = row.inspection_system_id != null;
    if (isSystem) {
        const on = !!row.completed_by_subcontractor;
        return (React.createElement("label", { className: `qmb-sw-cell qmb-sw-cell--leading${on ? ' is-on' : ''}` },
            React.createElement("span", { className: "qmb-sw-label" }, translate('sub_toggle.exclude_label', { namespace })),
            React.createElement("span", { className: `qmb-sw${on ? ' is-on' : ''}`, role: "switch", "aria-checked": on, "aria-label": translate('sub_toggle.mark_aria', { namespace, name: row.name }), tabIndex: 0, onClick: () => onToggle(row, !on), onKeyDown: (e) => {
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        onToggle(row, !on);
                    }
                } })));
    }
    return (React.createElement("span", { className: "qmb-sw-cell is-muted" },
        React.createElement("span", { className: "qmb-status-text" }, translate('sub_toggle.included_label', { namespace })),
        React.createElement("i", { className: "fa-regular fa-circle-question qmb-help-inline", title: translate('sub_toggle.not_available_tooltip', { namespace }), "aria-hidden": "true" })));
}
